export const secondaryServices = [
  'Bautizos',
  'Noche_de_Parejas',
  'Noche_de_Influencia',
  'Noche_con_el_Espiritu_Santo',
  'Entrenamiento_para_Lideres',
  'Presentacion_de_Bebes',
  'Encuentro_Presencial.',
  'Youth_Night',
  'Cyphers',
];

export const churchServices = ['Auditorio_Principal', 'Servicio_Especial', ...secondaryServices];

export const generacionesServices = [
  'Generaciones_de_0_a_3',
  'Generaciones_de_4_a_6',
  'Generaciones_de_7_a_9',
  'Generaciones_de_10_a_13',
];

export const CheckinURL = (event) => {
  let eventURL = '';
  if (event === 'crecer') {
    eventURL = `crecer/crecerAttendance`;
  }
  if (event === 'Auditorio_Principal') {
    eventURL = `event/church-service`;
  }
  return eventURL;
};
